var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPin(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5625 7.5C11.5625 8.63909 10.6391 9.5625 9.5 9.5625C8.36091 9.5625 7.4375 8.63909 7.4375 7.5C7.4375 6.36091 8.36091 5.4375 9.5 5.4375C10.6391 5.4375 11.5625 6.36091 11.5625 7.5Z",
    stroke: "#FF7926",
    strokeWidth: 1.13,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9375 7.5C14.9375 10.916 11.8815 14.0125 10.3515 15.3486C9.85833 15.7794 9.14167 15.7794 8.64847 15.3486C7.11853 14.0125 4.0625 10.916 4.0625 7.5C4.0625 4.49695 6.49695 2.0625 9.5 2.0625C12.503 2.0625 14.9375 4.49695 14.9375 7.5Z",
    stroke: "#FF7926",
    strokeWidth: 1.13,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPin);
export default __webpack_public_path__ + "static/media/pin.a32916ba15547dfb9f1279f941a02fbb.svg";
export { ForwardRef as ReactComponent };